import { render, staticRenderFns } from "./_offers.table.vue?vue&type=template&id=0f9b452d&scoped=true"
import script from "./_offers.table.vue?vue&type=script&lang=js"
export * from "./_offers.table.vue?vue&type=script&lang=js"
import style0 from "./_offers.table.vue?vue&type=style&index=0&id=0f9b452d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b452d",
  null
  
)

export default component.exports